import { Body, Link, Stack } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import { getMarketHasCompanyCreditCheck } from '~/constants/markets';
import useTranslate from '~/hooks/useTranslate';
import { ApiStatus, RootState } from '~/store/types/sharedTypes';
import useGoToNextStep from '../../Steps/useGoToNextStep';

export const PersonalInformationFooter = () => {
  const {
    onboardingApplication: { apiStatus },
    intl: { market },
  } = useSelector((state: RootState) => state);
  const t = useTranslate();

  const onNextStepClick = useGoToNextStep();

  return (
    <Stack align="center">
      {getMarketHasCompanyCreditCheck(market) && (
        <Body color="textDark.200" size="sm">
          {t('Onboarding.MarketingConsent', {
            next: `"${t('Onboarding.Next')}"`,
            email: (
              <a href="mailto:privacy@qred.com">
                <Link size="sm">privacy@qred.com</Link>
              </a>
            ),
          })}
        </Body>
      )}

      <NextButton
        label="Onboarding.Next"
        showLoadingSpinner={apiStatus.patch === ApiStatus.Started}
        action={onNextStepClick}
      />
    </Stack>
  );
};
